import { ReactQuestionFactory } from "survey-react-ui";
import {
  QuestionExpressionModel,
  RendererFactory,
  SurveyModel,
} from "survey-core";
import { createElement, FC } from "react";
import { Button } from "../ui";
import { ExplainerContent } from "../organisms/explainer-content";
import { ChevronRight } from "../icons";
import { T } from "@tolgee/react";
import { getExplainerExpression } from "../../utils";

interface ExplainerPageContentProps {
  question: QuestionExpressionModel;
}

const ExplainerPageContent: FC<ExplainerPageContentProps> = ({ question }) => {
  const { expression, title, survey } = question;
  const data = { title, ...getExplainerExpression(expression) };

  const onBeginQuestionnaireClick = () => (survey as SurveyModel).nextPage();

  return (
    <div className="grid gap-5 md:gap-[30px]">
      <ExplainerContent data={data} />
      <div className="flex justify-end">
        <Button color="indigo" onClick={onBeginQuestionnaireClick}>
          <div className="flex items-center justify-center gap-2">
            <span className="text-sm font-semibold text-white">
              <T keyName="button-begin-questionnaire" />
            </span>
            <ChevronRight size={20} color="white" />
          </div>
        </Button>
      </div>
    </div>
  );
};

ReactQuestionFactory.Instance.registerQuestion(
  "sv-explainer-page-content-expression",
  function (props: any) {
    return createElement(ExplainerPageContent, props);
  }
);

RendererFactory.Instance.registerRenderer(
  "expression",
  "explainer-page-content-expression",
  "sv-explainer-page-content-expression"
);
